import {
  distSqPointSegment,
  pointInRect,
  polylineMinDistSq,
  hitCornerHandle,
} from './geometry';
import { getElementBounds } from './elementBounds';

const TMP_CTX =
  typeof document !== 'undefined' ? document.createElement('canvas').getContext('2d') : null;

/**
 * Find topmost element at point. Corner handles only apply to `selectedId` element.
 * @param {number} px
 * @param {number} py
 * @param {object[]} elements
 * @param {string | null} selectedId
 * @param {number} pickThreshold natural px
 */
export function hitTest(px, py, elements, selectedId = null, pickThreshold = 12) {
  const th2 = pickThreshold * pickThreshold;

  for (let i = elements.length - 1; i >= 0; i--) {
    const el = elements[i];
    if (selectedId === el.id) {
      const b = getElementBounds(el, TMP_CTX);
      const h = hitCornerHandle(px, py, b.x, b.y, b.w, b.h, pickThreshold);
      if (h) return { id: el.id, handle: h };
    }
  }

  for (let i = elements.length - 1; i >= 0; i--) {
    const el = elements[i];
    if (el.type === 'rect' || el.type === 'blur') {
      if (pointInRect(px, py, el.x, el.y, el.w, el.h)) return { id: el.id, handle: null };
    } else if (el.type === 'arrow') {
      const d = distSqPointSegment(px, py, el.x1, el.y1, el.x2, el.y2);
      if (d <= th2 * 2) return { id: el.id, handle: null };
    } else if (el.type === 'path') {
      const wide = (el.strokeWidth || 2) + pickThreshold;
      const d = polylineMinDistSq(px, py, el.points);
      if (d <= wide * wide) return { id: el.id, handle: null };
    } else if (el.type === 'text') {
      if (!TMP_CTX) continue;
      const b = getElementBounds(el, TMP_CTX);
      if (pointInRect(px, py, b.x, b.y, b.w, b.h)) return { id: el.id, handle: null };
    }
  }
  return null;
}
